module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"copyPage":"Copy link","linkCopiedToClipBoard":"Link copied to clipboard"},"fr":{"copyPage":"Copier le lien","linkCopiedToClipBoard":"Lien a été copié"},"de":{"copyPage":"Link kopieren","linkCopiedToClipBoard":"Link wurde kopiert"}}')
  delete Component.options._Ctor
}
